import React from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import qp from 'query-parse';
import BaseRequestsPaginationPage from '../../../../components/admin/containers/BaseRequestsPaginationPage';
import GeneralTableRow from '../../../../components/accounting/table/row';
import InfoTooltip from '../../../../components/common/tooltip/info/index';
import Loading from '../../../../components/common/loading/index';
import AllActionButtons from '../../../../components/actions/all';
import requestPageContainer from '../../../../containers/accounting/request-page';
import { withNamespaces } from 'react-i18next';
import i18n from "i18next";
import cookieAndLocalStorage from "../../../../helpers/cookieAndLocalStorage";

class AccountingRequestsPage extends React.Component {
  constructor(props) {
    super(props);
    this.changeFilter = this.changeFilter.bind(this);
    this.actionButtonEvents = {
      approveRequest: async (payload) => {
        if (payload.isAbroad) {
          if (_.isEmpty(payload.exchangeRate)) {
            await props.fetchExchangeRate(payload.currency);
            payload.exchangeRate =
              props.exchangeRate && props.exchangeRate.exchangeRate;
          }
        } else {
          payload.exchangeRate = 1;
        }
        await this.props.approveRequest({ exchangeRate: payload.exchangeRate, harcirahId: payload.harcirahId });
      },
      rejectedRequest: async (payload) => {
        await this.props.rejectRequest(payload);
      },
      renderPage: async () => {
        await this.callFilterAfterReject();
      }
    };

    this.state = {
      requestStatus: 'all'
    };
  }
  async componentDidMount() {

    const { isCheckToken,isActive } = this.props;
    if ( isActive === true ){
      await isCheckToken();
    }
    if(isActive === false){
      cookieAndLocalStorage()
    }
  }
  async componentWillMount(){
    const { isCheckToken,isActive } = this.props;
    if ( isActive === true ){
      await isCheckToken();
    }
    if(isActive === false){
      cookieAndLocalStorage()
    }
  }

  async callFilterAfterReject() {
    const currentQuery = qp.toObject(this.props.location.search.substring(1));

    // requestStatus değerini kontrol et ve gerekirse değiştir
    let requestStatusValue = currentQuery.requestStatus ? currentQuery.requestStatus : 'all';
    if (requestStatusValue === 'waiting_for_cancelled') {
      requestStatusValue = 'waiting_for_accounting_cancelled';
    }

    const filter = {
      month: currentQuery.month ? currentQuery.month : 0,
      year: currentQuery.year ? currentQuery.year : 0,
      requestStatus: requestStatusValue,
      page: this.props.match.params.page,
    };

    await this.changeFilter(filter);
  }

  async changeFilter(filter) {
    const {
      month, year, page, requestStatus,
    } = filter;
    const { fetchRequests } = this.props;

    // requestStatus değerini kontrol et ve gerekirse değiştir
    let updatedRequestStatus = requestStatus;
    if (requestStatus === 'waiting_for_cancelled') {
      updatedRequestStatus = 'waiting_for_accounting_cancelled';
    }

    this.setState({ requestStatus: updatedRequestStatus });

    await fetchRequests({
      month, year, activePage: page, requestStatus: updatedRequestStatus, rowCount: 10,
    });
  }

  render() {
    const {
      requestStore, pageCount, selectRequest, match, t, isOverLimitCheckExist
    } = this.props;

    return (
      <BaseRequestsPaginationPage
        filterOptionValue="accounting"
        pageCount={pageCount}
        requestType="accounting/requests"
        changeFilter={this.changeFilter}
      >
        <div className="col-md-12">
          <div className="card">
            <div className="content table-responsive table-full-width">
              <Loading loading={requestStore.loading} rows={5} colSpan={9}>
                <div className="requests">
                  <div className="requests-column">
                    <div className="row">
                      <div className="col-md-first" />
                      <div className="col-md-1">
                        <h5>
                               {t('selection')}
                        </h5>
                      </div>
                      <div className="col-md-2">
                        <h5>
                              {t('nameSurname')}
                        </h5>
                      </div>
                      <div className="col-md-2">
                        <h5>
                              {t('travelDate')}
                        </h5>
                      </div>
                      <div className="col-md-2">
                        <h5>
                              {t('reasonForTravel')}
                        </h5>
                      </div>
                      <div className="col-md-1">
                        <h5>
                             {t('cityCounty')}
                        </h5>
                      </div>
                      <div className="col-md-1">
                        <InfoTooltip info={t('travelExpensesGross')}>
                          <h5>
                             {t('travelExpensesGross')}
                          </h5>
                        </InfoTooltip>
                      </div>
                      <div className="col-md-1">
                        <InfoTooltip info={t('individualAccommodationNet')}>
                          <h5>
                            {t('individualAccommodationNet')}
                          </h5>
                        </InfoTooltip>
                      </div>
                      <div className="col-md-last">
                        <h5>
                            {t('transaction')}
                        </h5>
                      </div>
                    </div>
                  </div>
                  <div className="requests-content">
                    {requestStore.requests.map(request => (
                      <GeneralTableRow
                        actionButtonEvents={this.actionButtonEvents}
                        key={request.group_id}
                        select={selectRequest}
                        request={request.harcirah[0]}
                        group_id={request.group_id}
                        subRequest={request.harcirah}
                        isOverLimitCheckExist={isOverLimitCheckExist}
                      />
                    ))}
                  </div>
                </div>
              </Loading>
            </div>
          </div>
          <AllActionButtons
            actionButtonEvents={this.actionButtonEvents}
            requestStore={requestStore}
            selectRequest={selectRequest}
            pageCount={match.params.page}
            requestStatus={this.state.requestStatus}
          />
        </div>
      </BaseRequestsPaginationPage>
    );
  }
}


export default withNamespaces()(connect(...requestPageContainer)(AccountingRequestsPage));



// WEBPACK FOOTER //
// ./src/pages/travel-expense/detail/accounting/index.js